/* eslint-disable */
import { Component } from 'react';
import { ReduxHOC } from 'HOC';
import { _, Utils } from 'Helpers'
import Slider from 'react-slick';


function AdItem({ item, className = '',lobbyBanner }) {
  return (
    <div {...{ className: `banner-item ${className}` }}>
      {item.target_url ?
        <a href={item.target_url} target='_blank' rel="noopener noreferrer">
          <img className={`multi-class ${lobbyBanner ? 'n-m' : ''}`} src={item.image} alt=""
            style={{
              width: `${item.height * 100}%`, height: `${100 / item.width}%`
            }}
          />
        </a>
        :
        <img className={`multi-class ${lobbyBanner ? 'n-m' : ''}`} src={item.image} alt=""
          style={{
            width: `${item.height * 100}%`, height: `${100 / item.width}%`
          }}
        />
      }
    </div>
  )
}

class MultiBanner extends Component {
  render() {
    const { root, type, paddingTop, paddingBottom, bannerLobby } = this.props;
    
    const lobbyBanner = JSON.parse(localStorage.getItem('bannerLobby') || 'null') || [];
    let contestData = JSON.parse(localStorage.getItem('contestData') || 'null') || {};

    if (type === '') return null;

    const _bannerData = _.filter(root.BannerData, o => o.banner_type_id == type);
    const _bannerDataLobby = _.filter(lobbyBanner, o => o.banner_type_id == type);

    const matchingItems = _bannerDataLobby.filter(item => String(item.contest_id) === String(contestData.contest_id));
    const otherItems = _bannerDataLobby.filter(item => String(item.contest_id) === "0");

    const displayItems = matchingItems.length > 0 ? matchingItems : otherItems;


    var SliderSettingsOne = {
      infinite:  _bannerDataLobby.length > 3 ? true : false,
      // autoplay:true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      pauseOnHover: true,
      nitialSlide: 0,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            initialSlide: 1,
            infinite:false,
            arrows: false,
            slidesToShow: 1.25,
            slidesToScroll: 1,
            dots: false,
            centerMode:true,
            centerPadding:"10px",          
          }
        },
      ]
    };

    return (
      <>
      {
        bannerLobby ? 
        <div {...{
          className: `banner-wrapper custm-arr-slide 11 ${paddingTop ? ' p-t' : ''}`
        }}>
          {
            _bannerDataLobby.length == 1 ?
              <AdItem item={_bannerDataLobby[0]} className={`box single-view ${_bannerDataLobby[0].height}x${_bannerDataLobby[0].width}`} lobbyBanner={lobbyBanner} />
              :
              <Slider {...SliderSettingsOne}>
              {_.map(displayItems, (item, idx) => {
                  return (
                    <div key={idx} className={`w-ffff 1`}>
                      <AdItem item={item} className={`box${lobbyBanner[0]?.height}x${lobbyBanner[0]?.width}`} lobbyBanner={lobbyBanner} />
                    </div>
                  );
                })}

              </Slider>
          }
        </div>
        :
        <div {...{
          className: `banner-wrapper custm-arr-slide 22 ${paddingTop ? ' p-t' : ''}`
        }}>
          {
            _bannerData.length == 1 ?
              <AdItem item={_bannerData[0]} className={`box single-view ${_bannerData[0].height}x${_bannerData[0].width}`} />
              :
              <Slider {...SliderSettingsOne}>
                {_.map(_bannerData, (item, idx) => {
                  if(item.contest_id !== contestData.contest_id && bannerLobby){
                    return''
                  } 
                  return (
                    <div className='w-ffff 2'>
                      <AdItem item={item} key={idx} className={`box${_bannerData[0].height}x${_bannerData[0].width}`} />
                    </div>
                  )
                })}
              </Slider>
          }
        </div>

      }
      

       
      </>
    )
  }
}

MultiBanner.defaultProps = {
  type: '',
  'paddingTop': false,
  'paddingBottom': false,
}
export default ReduxHOC(MultiBanner);
/* 
  type value should be:
  default: ''
  7: position1 (1x1)
  8: position2 (1x2)
  9: position3 (1x3)
  10: position4 (1x2)
  11: position5 (1x3)
 */